import { render, staticRenderFns } from "./PackageToursTab.vue?vue&type=template&id=3557c7ed&scoped=true"
import script from "./PackageToursTab.vue?vue&type=script&lang=js"
export * from "./PackageToursTab.vue?vue&type=script&lang=js"
import style0 from "./PackageToursTab.vue?vue&type=style&index=0&id=3557c7ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3557c7ed",
  null
  
)

export default component.exports